const ChevronVertical = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2484 2.8235C11.6671 2.41821 12.3319 2.41821 12.7507 2.8235L18.1507 8.05017C18.5792 8.465 18.5904 9.14873 18.1756 9.57732C17.7607 10.0059 17.077 10.0171 16.6484 9.60223L11.9995 5.10257L7.35065 9.60223C6.92206 10.0171 6.23834 10.0059 5.8235 9.57732C5.40867 9.14873 5.41982 8.465 5.84841 8.05017L11.2484 2.8235ZM5.8235 14.4217C6.23834 13.9932 6.92206 13.982 7.35065 14.3968L11.9995 18.8965L16.6484 14.3968C17.077 13.982 17.7607 13.9932 18.1756 14.4217C18.5904 14.8503 18.5792 15.5341 18.1506 15.9489L12.7507 21.1756C12.3319 21.5809 11.6671 21.5809 11.2484 21.1756L5.84841 15.9489C5.41982 15.5341 5.40867 14.8503 5.8235 14.4217Z"
    />
  </>
);

export default ChevronVertical;
